module.exports = __webpack_public_path__ + "static/media/drop-off.a994b1dc.svg";